<mat-dialog-content class="mat-typography">
<div   class="p-[1rem] flex flex-col items-center">
    <div class="w-full max-w-xl">
        <h1 class="text-2xl font-bold">HOJA DE ACEPTACIÓN DE CERTIFICADO ELECTRONICO CUALIFICADO RÉGIMEN OBLIGATORIO DE USO DEL CERTIFICADO ELECTRONICO: “CERTIFICADO DE PERSONA FÍSICA REPRESENTANTE DE EMPRESA EMITIDO EN SOFTWARE”</h1>
  
        <p>
        a) Que existen unas condiciones generales del servicio incorporadas en el texto de divulgación del certificado o PDS, y una declaración de prácticas de certificación, que regulan la emisión y utilización del certificado electrónico emitido porvinCAsign, cuyo texto íntegro se puede consultar en la dirección de Internet, https://policy.vincasign.net.
        </p>
        <p>
        b) Que el certificado electrónico emitido y el resto de los elementos que forman parte de la identificación electrónica son únicos para cada usuario. El certificado debe ser protegido por un código secreto (PIN), que sólo conoce el titular y que le será entregado en el momento de la emisión del certificado. Para utilizar el certificado es imprescindible conocer este código.
        </p>
        <p>
        c) Que este certificado permite al titular del certificado generar firmas electrónicas e identificarse de forma electrónica en aquellos sistemas de información que soporten este tipo de autenticación.
        </p>
        <p>
        d) Que el FIRMANTE debe custodiar, de forma diligente, el PIN que permite utilizarlo, para evitar que otras personas puedan suplantar su identidad y firmar documentos en su nombre, o acceder a mensajes confidenciales o sistemas de información de acceso restringido.
        </p>
        <p>
        e) Que, si el FIRMANTE detecta cualquier indicio de que su identificación electrónica ha podido ser utilizada por otras personas, tendrá que suspender el uso del certificado y notificarlo inmediatamente al responsable del servicio de certificación del SUSCRIPTOR, o a vinCAsign, para pedir la revocación del certificado y, en su caso, la emisión de uno nuevo.
        </p>
        <p>
        f) Que ante cualquier necesidad de información adicional, respecto de la utilización de los certificados emitidos en nombre de vinCAsign, el FIRMANTE se podrá dirigir al SUSCRIPTOR, al responsable del servicio de certificación del SUSCRIPTOR, y/o a VINTEGRIS.
        </p>
        <p>
        g) Que con el fin de obtener los correspondientes certificados, y dentro del marco del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos), el SUSCRIPTOR ha comunicado a vinCAsign los datos identificativos del FIRMANTE con el fin de emitir y gestionar el certificado corporativo de persona física emitido en software, en el ámbito de la relación de trabajo entre dicho FIRMANTE y el SUSCRIPTOR, todo ello a los efectos de lo previsto en el artículo 28 del Reglamento general de protección de datos.
        </p>
        <p>
        h) Que sabe que, en cumplimiento de lo establecido en los artículos 24.2 y 28 del Reglamento (UE) 910/2014 del Parlamento Europeo y del Consejo de 23 de julio de 2014, los datos contenidos en el certificado corporativo de persona física emitido en software están publicados en la página web de vinCAsign a efectos del Registro de Certificados y de las listas de revocación, toda vez que ha prestado su consentimiento durante el proceso de solicitud.
        </p>

        <h1 class="pt-3 font-bold text-2xl">
        ACTO DE ACEPTACIÓN DEL CERTIFICADO ELECTRÓNICO
        </h1>
        <p>
        Firmo el presente documento para dejar constancia:
        </p>
        <p>
        Que ha sido informado del contenido del texto de divulgación del certificado o PDS, en el que se incluyen las condiciones generales del servicio aplicable al certificado corporativo de persona física emitido en software.
        </p>
        <p>
        Que ha sido informado del régimen obligatorio de uso del certificado emitido, sus condiciones de uso y sus responsabilidades.
        </p>
        <p>
        Que ha sido informado de las circunstancias relativas al tratamiento de sus datos personales para la correcta emisión y gestión del certificado que se emite.
        </p>
        <p>
        Firma de conformidad, en virtud de la cual ha leído y entiende las obligaciones y responsabilidades que asume.
        </p>
    </div>
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <ng-container *ngIf="funderStyles">
    <button 
    [style.border-radius]="funderStyles.btnRound + 'px'"
    class="px-8 bg-slate-300/30" 
    mat-flat-button mat-dialog-close>{{ texts.cancel }}</button>
    <button         
      [style.color]="funderStyles.colors.btnText"
      [style.background]="funderStyles.colors.btnBg"
      [style.border-radius]="funderStyles.btnRound + 'px'"
      class="px-8" 
      mat-flat-button type="button" [mat-dialog-close]="true" cdkFocusInitial>{{ texts.accept }}</button>
  </ng-container>
</mat-dialog-actions>